import IsDebugChecker from '@/lib/debug/is-debug/IsDebugChecker';

import Logger from './Logger';

export default new Logger(new IsDebugChecker());
